import BanqueFormController from './banque.form.controller';

export default {
    template: require('./banque.form.html'),
    controller: BanqueFormController
};
